<template>
  <Modal name="QUOTE_PAYMENT_MODAL" :title="title" :width="580">
    <template slot="body">
      <div class="recharge__wrapper" v-if="quotePaymentType === null && !payWithFci">
        <div
          class="recharge__item"
          @click="setQuotePaymentType('ASAAS_CREDIT_CARD')"
        >
          <v-icon>
            mdi-credit-card-outline
          </v-icon>
          <h2 class="mt-3">
            <span class="d-block caption">
              {{ $t('quote.modal.payWith') }}
            </span>
            <span class="font-weight-bold">
              {{ $t('quote.modal.creditCard') }}
            </span>
          </h2>
          <div class="mw-200 mx-auto">
            <v-divider class="my-3 grey lighten-3" />
            <h6 class="d-block body-2 grey--text">
              {{ $t('recharge.paymentInfo.credit') }}
            </h6>
          </div>
        </div>
        <div class="recharge__item" @click="setQuotePaymentType('ASAAS_PIX')">
          <PixIcon width="50" height="57" opacity="0.1" />
          <h2 class="mt-3">
            <span class="d-block caption">
              {{ $t('quote.modal.payWith') }}
            </span>
            <span class="font-weight-bold">
              {{ $t('quote.modal.pix') }}
            </span>
          </h2>
          <div class="mw-200 mx-auto">
            <v-divider class="my-3 grey lighten-3" />
            <h6 class="d-block body-2 grey--text">
              {{ $t('recharge.paymentInfo.pix') }}
            </h6>
          </div>
        </div>
      </div>

      <QuotePaymentPix v-if="quotePaymentType === 'ASAAS_PIX'" />
      <QuotePaymentCreditCard v-if="quotePaymentType === 'ASAAS_CREDIT_CARD'" />
      <QuotePaymentFci v-if="payWithFci" />
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import PixIcon from '@/components/icons/Pix'
import QuotePaymentPix from './QuotePaymentPix'
import QuotePaymentCreditCard from './QuotePaymentCreditCard'
import QuotePaymentFci from './QuotePaymentFci'

import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'QuotePaymentModal',

  components: {
    Modal,
    PixIcon,
    QuotePaymentPix,
    QuotePaymentCreditCard,
    QuotePaymentFci,
  },

  computed: {
    ...mapGetters(['quotePaymentType', 'payWithFci', 'quoteItems']),

    title() {
      if (this.payWithFci) return this.$t('quote.modal.payWithFciTitle')
      else return this.quotePaymentType
        ? this.$t('quote.modal.paymentSelected')
        : this.$t('quote.modal.paymentSelectTitle')
    },
  },

  methods: {
    ...mapMutations(['setQuotePaymentType']),
  },
}
</script>
